import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Show, useAuth } from "@clerk/react";
import { toast } from "sonner";
import { BellRing, Check } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";

export const SizeAlert = ({ product, size, color }) => {
  const call = useApi();
  const { isSignedIn } = useAuth();
  const { pathname } = useLocation();
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const label = `talla ${size}${color ? ` (${color})` : ""}`;
  const back = `${window.location.origin}${pathname}?size=${encodeURIComponent(size)}`;

  useEffect(() => {
    if (!isSignedIn) return;
    call("get", "/alerts/mine").then((r) => {
      if (r.data.some((a) => a.status === "pending" && a.product_id === product.id && a.size === size && (a.color || "") === color)) setDone(true);
    }).catch(() => {});
  }, [isSignedIn, call, product.id, size, color]);

  const subscribe = async () => {
    setBusy(true);
    try {
      await call("post", "/alerts", { product_id: product.id, size, color });
      setDone(true);
      toast.success("¡Listo! Te avisaremos por email");
    } catch (e) { toast.error(errMsg(e, "No se pudo crear el aviso")); }
    setBusy(false);
  };

  return (
    <div className="mt-8 border border-verde/30 bg-verde/5 p-5" data-testid="size-alert-box">
      <p className="font-semibold flex items-center gap-2"><BellRing className="w-4 h-4 text-verde" /> La {label} está agotada</p>
      <p className="text-sm text-slate-600 mt-1">Te enviamos un email automáticamente en cuanto vuelva a haber stock.</p>
      <Show when="signed-in">
        {done ? (
          <p className="mt-4 text-sm font-semibold text-verde flex items-center gap-2" data-testid="size-alert-done"><Check className="w-4 h-4" /> Aviso activado. Lo verás en Mi cuenta.</p>
        ) : (
          <button className="btn-primary btn-verde mt-4 w-full" onClick={subscribe} disabled={busy} data-testid="size-alert-button">
            {busy ? "Guardando…" : `Avísame cuando llegue la ${label}`}
          </button>
        )}
      </Show>
      <Show when="signed-out">
        <Link to={`/sign-in?redirect_url=${encodeURIComponent(back)}`} className="btn-primary btn-verde mt-4 w-full" data-testid="size-alert-signin">
          Inicia sesión para recibir el aviso
        </Link>
      </Show>
    </div>
  );
};
